/************
 Swipers
 ************/

// thumbnails mobile
let productV23ThumbnailImages = new Swiper("#productV23ThumbnailsSwiper", {
    slidesPerView: "auto",
    spaceBetween: 5,
    breakpoints: {
        800: {
            slidesPerView: 6,
        }
    },
    loop: true,
    navigation: {
        nextEl: '#productV23ThumbnailsNext',
        prevEl: '#productV23ThumbnailsPrev',
    },
});

// play video in the currently active slide (videos are muted + loop, so we never pause)
function playActiveSlideVideoV23(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const video = activeSlide?.querySelector("video");
    if (!video) {
        return;
    }
    video.play();
}

// main swiper
let productV23Images = new Swiper("#productV23Swiper", {
    navigation: {
        nextEl: '#productV23Swiper .productV23SwiperNext',
        prevEl: '#productV23Swiper .productV23SwiperPrev',
    },
    loop: true,
    thumbs: {
        swiper: productV23ThumbnailImages
    },
    on: {
        init: function () {
            playActiveSlideVideoV23(this);
        },
        slideChange: function () {
            playActiveSlideVideoV23(this);
        }
    }
});

// gallery desktop
document.querySelectorAll(".productV23GalleryItem").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productV23Images.slideTo(index);
    });
});

/********************
 Video Popup
 *******************/

// open video
document.querySelectorAll('.productV23Video')?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const popup = document.querySelector(".videoPopup");
        popup.showModal();

        // check if we're on mobile and if .videoPopupVideo.mobileOnly exists
        if (window.innerWidth < 800 && popup.querySelector(".videoPopupVideo.mobileOnly")) {
            popup.querySelector(".videoPopupVideo.mobileOnly").play();
        } else {
            popup.querySelector("video").play();
        }
    })
})


/*****************
 Reviews
 ****************/

document.querySelector("#productV23Review")?.addEventListener("click", function () {
    window.scrollTo({
        top: document.querySelector("#looxReviews").offsetTop - 100,
        behavior: "smooth"
    });
})


/**************
 Function To Update Pricing
 ***************/

// update active variant
function updateProductV18(skipImage) {
    // There are 3 senarios to determine the active variant
    // 1. Has only a default variant
    // 2. the color/background swatch
    // 3. the basic dropdown

    // check for an active color swatch
    if (product.variants.length === 1) {
        activeVariant = product.variants[0];
    } else if (document.querySelector(".productV23FormGroup.active")) {
        activeVariant = product.variants.filter((variant) => {
            return variant.id === parseInt(document.querySelector(".productV23FormGroupFlexColor:checked").value)
        })[0];
    } else {
        activeVariant = product.variants.filter((variant) => {
            return variant.id === parseInt(document.querySelector("#productV23FormVariants").value)
        })[0];
    }

    // find variant image by matching filename (media.id and featured_image.id differ in shopify's media model)
    if (activeVariant.featured_image && !skipImage) {
        const variantFilename = activeVariant.featured_image.src.split("/").pop().split("?")[0];
        const variantImage = Array.from(document.querySelectorAll(".productV23SwiperSlide")).find(slide => {
            const img = slide.querySelector("img");
            return img && img.src.split("/").pop().split("?")[0] === variantFilename;
        });
        if (variantImage) {
            productV23Images.slideTo(getElIndex(variantImage));
        }
    }

    // in the variant available?
    let isAvailable = activeVariant.available;

    // default quantity and discount
    let quantity = 1;
    let discount = 0;

    // compute price and compare at price
    let total = activeVariant.price * quantity - discount;
    let compareAtTotal = activeVariant.compare_at_price * quantity;

    // check for add on
    if (document.querySelector(".productV23UpsellTop:checked")) {
        total += parseInt(document.querySelector(".productV23UpsellTop:checked").dataset.price);
        compareAtTotal += parseInt(document.querySelector(".productV23UpsellTop:checked").dataset.compare);
    }


    // update display
    if (total < compareAtTotal) {
        document.querySelector("#productV23PriceCompare").textContent = price(compareAtTotal, true);
        document.querySelector("#productV23PriceActual").textContent = `${price(total, true)}`;

        if (!document.querySelector('#productV23PriceSavings').classList.contains('noUpdate')) {
            document.querySelector("#productV23PriceSavings").textContent = `SAVE 40 %`;
        }
        document.querySelector("#productV23PriceSavings").classList.add('active');

    } else {
        document.querySelector("#productV23PriceCompare").textContent = "";
        document.querySelector("#productV23PriceActual").textContent = price(total, true);
        document.querySelector("#productV23PriceSavings").classList.remove('active');
    }


    // check if the variant is in stock
    if (isAvailable) {
        document.querySelector("#productV23ATC").classList.remove("oos");
        document.querySelector("#productV23ATC").textContent = document.querySelector("#productV23ATC").dataset.text;
    } else {
        document.querySelector("#productV23ATC").classList.add("oos");
        document.querySelector("#productV23ATC").textContent = "Sold Out — Notify Me When Available";
    }

    // keep the sticky bar in step with the new variant and button state
    updateStickyBar();
}

/*******************
 Product Form (Default and Group)
 ********************/

// color swatch support on change
document.querySelectorAll(".productV23FormGroupFlexColor").forEach(function (element) {
    element.addEventListener("change", function () {
        // update label
        this.parentElement.parentElement.parentElement.querySelector(".productV23FormGroupHeaderLabel").innerHTML = this.getAttribute("aria-label");

        // update price
        updateProductV18();
    });
});

/****************
 *  Quantity
 *************/

let quantity = 1;


/**************
 Product ATC
 ***************/

// add to cart button
/*Code for adding Shipping Insurance*/
document.querySelector("#productV23ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // check for out of stock
    if (this.classList.contains("oos")) {
        // check email
        let {value: email} = await Swal.fire({
            title: product.title,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        let formData = new FormData();
        formData.append("a", await klaviyo.account());
        formData.append("email", email);
        formData.append("g", "");
        formData.append("variant", activeVariant.id);
        formData.append("product", product.id);
        formData.append("platform", "shopify");
        formData.append("subscribe_for_newsletter", false);
        fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
            method: "POST",
            body: formData
        })

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");

    // determine which time of productV23 we're adding to cart
    // 1. Bundle
    // 2. Single Product

    // create form data
    let formData = {
        items: []
    };

    // check for add on
    let hideGifts = "false";
    if (document.querySelector(".productV23UpsellTop:checked")) {
        hideGifts = "true";
        formData.items.push({
            quantity: 1,
            id: parseInt(document.querySelector(".productV23UpsellTop:checked").dataset.id)
        })
    }

    // normal product
    formData.items.push({
        quantity: quantity,
        id: activeVariant.id,
        properties: {
            "_hide_free_gift_banner": hideGifts
        }
    });


    // check if we should go directly to checkout
    if (this.classList.contains('checkout')) {

        await clearCart();

        // add gift free gift
        formData.items.push(
            {
                quantity: 1,
                id: 47175294222586
            }
        )
        await addProduct(formData)

        window.location.href = '/checkout';

        // klaviyo tracking
        try {
            _learnq.push(['track', 'Added to Cart', item]);
        } catch (error) {
            console.error("Klaviyo tracking not found");
        }

        // remove loading animation
        this.classList.remove("loading");

        return;
    }


    // add productV23
    await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }


    // open cart
    await openCart();


    // remove loading animation
    this.classList.remove("loading");

});

//space
// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // click normal atc
        document.querySelector("#productV23ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart_addon"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // check the addon if not already checked
        if (!document.querySelector("#productV23AddonCheckboxInput").checked) {
            document.querySelector("#productV23AddonCheckbox").click();
        }


        // click normal atc
        document.querySelector("#productV23ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

/**************
 Sticky ATC
 ***************/

// ignore if noSticky class is present
if (!document.querySelector("#productV23ATC").classList.contains("noSticky")) {
    const stickyAtcObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                document.querySelector("#productV23ATC").classList.remove("sticky");
            } else {
                document.querySelector("#productV23ATC").classList.add("sticky");
            }
        });
    }, {
        rootMargin: "-100px 0px 0px 0px"
    })
    stickyAtcObserver.observe(document.querySelector("#productV23Content"));

}

/**************
 Sticky ATC Bar
 ***************/

// mirror the active variant and buy button state into the bar
// queries its own elements since updateProductV18 can run before this block
function updateStickyBar() {
    const stickyBar = document.querySelector("#productV23Sticky");

    // only rendered when the "Use Sticky ATC Bar" setting is on
    if (!stickyBar) {
        return;
    }

    // the bar's button is a copy of the real one, right down to the sold out label
    const atc = document.querySelector("#productV23ATC");
    const stickyATC = stickyBar.querySelector("#productV23StickyATC");
    stickyATC.textContent = atc.textContent;
    stickyATC.classList.toggle("oos", atc.classList.contains("oos"));

    // fall back to the product image for variants without their own
    let imageSrc = product.featured_image;
    if (activeVariant.featured_image) {
        imageSrc = activeVariant.featured_image.src;
    }
    if (imageSrc) {
        stickyBar.querySelector("#productV23StickyProductImage").src = imageSrc;
    }

    // variant line and swatches are only rendered when the product has a color picker
    const stickyVariant = stickyBar.querySelector("#productV23StickyProductInfoVariant");
    if (stickyVariant) {
        stickyVariant.textContent = `Color: ${activeVariant.title}`;
    }

    stickyBar.querySelectorAll(".productV23StickyProductInfoSwatchesItem").forEach(function (element) {
        element.classList.toggle("active", parseInt(element.dataset.variantId) === activeVariant.id);
    });
}

const stickyBar = document.querySelector("#productV23Sticky");

if (stickyBar) {
    const atc = document.querySelector("#productV23ATC");

    // one delegated handler for the swatches, routed through the color radios so the variant logic stays in one place
    stickyBar.querySelector("#productV23StickyProductInfoSwatches")?.addEventListener("click", function (e) {
        const swatch = e.target.closest(".productV23StickyProductInfoSwatchesItem");
        if (!swatch) {
            return;
        }

        // the price logic reads the first checked radio, so drive the active group
        const radio = document.querySelector(`.productV23FormGroup.active .productV23FormGroupFlexColor[value="${swatch.dataset.variantId}"]`);
        if (!radio) {
            return;
        }
        radio.checked = true;
        radio.dispatchEvent(new Event("change"));
    });

    // the bar's button is a proxy for the real one, popups and cart logic included
    stickyBar.querySelector("#productV23StickyATC").addEventListener("click", function () {
        atc.click();
    });

    // the real button owns the add to cart lifecycle, so mirror its spinner instead of running our own
    const stickyATCLoadingObserver = new MutationObserver(function () {
        stickyBar.querySelector("#productV23StickyATC").classList.toggle("loading", atc.classList.contains("loading"));
    });
    stickyATCLoadingObserver.observe(atc, {attributeFilter: ["class"]});

    // reveal the bar once the real button is scrolled past, not while it's still below the fold; the 80px inset stops edge flicker
    const stickyBarObserver = new IntersectionObserver(function (entries) {
        const scrolledPast = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        stickyBar.classList.toggle("active", scrolledPast);
    }, {
        threshold: 0,
        rootMargin: "0px 0px -80px 0px"
    });
    stickyBarObserver.observe(atc);

    // sync the initial paint with the real button's text
    updateStickyBar();
}


// event listeners for dropdown items
document.querySelectorAll(`.productV23DropdownTop`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});

/**************
 Upsell
 ***************/
document.querySelector('.productV23UpsellTop')?.addEventListener('change', function () {
    // dropdown
    document.querySelector(".productV23Upsell").classList.toggle("active");

    updateProductV18(true)
})

/**************
 Shipping Time
 ***************/

// Consistent random number generation using the hash as a seed
function generateSeededRandom(key, min, max) {
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = (hash << 5) - hash + key.charCodeAt(i);
        hash |= 0;
    }

    const x = Math.sin(hash) * 10000;
    const seed = x - Math.floor(x);

    return Math.floor(seed * (max - min + 1) + min);
}

let ordersRemaining = localStorage.getItem('ordersRemaining');

// check local storage for orders remaining and set
if (ordersRemaining && localStorage.getItem('productHandle') === product.handle) {
    if (document.querySelector('#productV23ShippingRemainingTxt')) {
        document.querySelector('#productV23ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
    }
} else {
    // generate random number and set local storage if not found
    ordersRemaining = generateSeededRandom(product.handle, 10, 100);
    localStorage.setItem('ordersRemaining', ordersRemaining);
    localStorage.setItem('productHandle', product.handle);

    if (document.querySelector('#productV23ShippingRemainingTxt')) {
        document.querySelector('#productV23ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
    }
}

// show shipping tomorrow
let date = new Date();
date.setDate(date.getDate() + 1);
date = date.toLocaleDateString('en-US', {month: 'short', day: 'numeric'});
document.querySelector('#productV23ShippingDateTxt').innerHTML = `Ships <strong>Tomorrow, ${date}</strong>`;


// check local storage for orders remaining and set
if (ordersRemaining && localStorage.getItem('productHandle') === product.handle) {
    document.querySelector('#productV23ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
} else {
    // generate random number and set local storage if not found
    ordersRemaining = generateSeededRandom(product.handle, 10, 100);
    localStorage.setItem('ordersRemaining', ordersRemaining);
    localStorage.setItem('productHandle', product.handle);
    document.querySelector('#productV23ShippingRemainingTxt').textContent = `${ordersRemaining} orders remaining`;
}